import * as React from 'react';

import { CurrencyListDataService } from 'src/app/general/currencies/list/currency-list.data';
import { CurrencyEditorView } from 'src/app/general/currencies/parts/currency-editor.view';

interface Props {
	value: number;
	label?: string;
	required?: boolean;
	mode: ControlMode;
	onChange: (value?: CurrencySummary) => void;
	setBusy(isBusy: boolean);
	onGetErrorMessage?: () => Promise<ValidationError[]>
}

export class CurrencyEditorController extends React.Component<Props, {}> {
	private dataService: CurrencyListDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.dataService = CurrencyListDataService.make();
	}

	query = async (keywords?: string): Promise<QueryResult<CurrencySummary>> => {
		this.dataService.searchKeywords = keywords;
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('iso3Name', 'asc', true);

		const items = await this.dataService.load(qry => qry);

		return {
			items,
			totalCount: items.length
		};
	}

	render() {
		return (
			<CurrencyEditorView
				currencies={{ query: this.query, dataSet: this.dataService }}
				currencyArrayObjectType={false}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/parts/currency-editor.controller.tsx